import type { Transaction } from "@/types/bridge-scanner.types";
import { BiTime } from "react-icons/bi";
import { FaMinus } from "react-icons/fa";
import { FiCheckCircle } from "react-icons/fi";
import colors from "@styles/settings/exported-colors.module.scss";
import { RiCloseCircleLine } from "react-icons/ri";
import { PiQuestionBold } from "react-icons/pi";

export const statusIconResolve = (status: Transaction["status"]) => {
  switch (status) {
    case "done":
      return {
        icon: <FiCheckCircle size={20} color={colors.greenYellow} />,
        text: "Completed",
      };
    case "wait-wh":
      return {
        icon: <BiTime size={22} color={colors.yellow} />,
        text: "Waiting for Wormhole",
      };
    case "wait-rb":
      return { icon: <BiTime size={22} />, text: "Waiting for rollup bridge" };
    case "wait-cc":
      return {
        icon: <BiTime size={22} color={colors.yellow} />,
        text: "Waiting for child chain",
      };
    case "wait-dsp":
      return {
        icon: <BiTime size={22} color={colors.dodgerBlue} />,
        text: "Waiting for dispenser",
      };  
    case "manual":
      return { icon: <BiTime size={22} />, text: "Awaiting manual action" };
    case "error":
      return {
        icon: <RiCloseCircleLine size={22} color={colors.red} />,
        text: "Error",
      };
    default:
      return {
        icon: <PiQuestionBold color={colors.greyDark} />,
        text: "Unknown",
      };
  }
};
